import { Text, Stack } from 'basis';
import React from 'react';
import { LayoutPage, LayoutForm } from 'components';
import { Routes } from 'types';
import { config } from '_config';

export const AchSubmitted: React.FC = () => {
  return (
    <LayoutPage step="update" hideProgressStepper>
      <LayoutForm>
        <Stack gap="8">
          <Text as="h1" textStyle="heading5" textStyle-md="heading4">
            {config.routeConfig[Routes.achSubmitted].pageTitle}
          </Text>
          <Text>
            Your application is being reviewed by one of our team members. We'll get back to you as soon as possible.
          </Text>
          <Text>
            Thank you for your patience.
          </Text>
          <Text>
            The Latitude Team
          </Text>
        </Stack>
      </LayoutForm>
    </LayoutPage>
  );
};
